// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-dropdown[data-v-23598cde]{font-size:24px}.el-dropdown-link[data-v-23598cde]{cursor:pointer}.el-dropdown-menu.el-popper[data-v-23598cde]{margin:-8px 0 0 8px}", ""]);
// Exports
module.exports = exports;
